module.exports = __webpack_public_path__ + "img/artificial-sun.d9b16b13.jpg";